import { z } from "zod";

/**
 * BL-25 (0288): publish one Terms or Privacy draft. Superadmin-only at the
 * route; `publish_legal_document` retires the current version of the same kind
 * in the same transaction and writes the audit row. Drafts themselves are
 * written straight to `legal_documents` under RLS — only publishing needs the
 * service role.
 */
export const publishLegalDocumentSchema = z.object({
  id: z.string().uuid(),
});

export type PublishLegalDocumentInput = z.infer<typeof publishLegalDocumentSchema>;
